import raf from 'raf'

export default {
  data () {
    return {
      rect: null,
      rafHandle: null,
      mousePosition: {x: 0, y: 0},
      position: {x: 0, y: 0},
      realPosition: {x: 0, y: 0},
      ratio: 50,
      indice: 0.05,
      isActive: false
    }
  },
  methods: {
    onMouseMove (event) {
      this.mousePosition.x = event.clientX
      this.mousePosition.y = event.clientY
    },
    animate () {
      this.position.x = this.isActive ? Math.floor((this.mousePosition.x - (this.rect.left + (this.rect.width / 2))) / this.ratio) : 0
      this.position.y = this.isActive ? Math.floor((this.mousePosition.y - (this.rect.top + (this.rect.height / 2))) / this.ratio) : 0

      const dx = (this.position.x - this.realPosition.x) * this.indice
      const dy = (this.position.y - this.realPosition.y) * this.indice
      this.realPosition.x += dx
      this.realPosition.y += dy

      if (Math.abs(dx) > 0.01 || Math.abs(dy) > 0.01) { this.update() }

      this.rafHandle = raf(this.animate)
    },
    update () {
      const tr = 'translate3d( ' + this.realPosition.x + 'px, ' + this.realPosition.y + 'px, 0px )'
      this.$el.style.webkitTransform = tr
      this.$el.style.MozTransform = tr
      this.$el.style.msTransform = tr
      this.$el.style.OTransform = tr
      this.$el.style.transform = tr
    },
    onResize () {
      this.rect = this.$el.getBoundingClientRect()
    },
    startParallax () {
      // if (this.$tools.isTouchDevice()) return

      this.onResize()
      this.destroyParallax()
      this.isActive = true
      // this.onMouseMove()
      this.rafHandle = raf(this.animate)
      window.addEventListener('resize', this.onResize)
    },
    stopParallax () {
      this.isActive = false
      window.removeEventListener('resize', this.onResize)
    },
    destroyParallax () {
      this.stopParallax()
      if (this.rafHandle) { raf.cancel(this.rafHandle) }
    },
    initMouseEvents () {
      this.stopParallax()
      this.$el.addEventListener('mouseenter', this.onMouseEnter)
      this.$el.addEventListener('mouseleave', this.onMouseLeave)
      this.isActive = false
    },
    onMouseEnter () {
      if (!!('ontouchstart' in window) || !!('onmsgesturechange' in window)) return
      this.startParallax()
      this.$el.classList.add('is-over')

      this.$el.addEventListener('mousemove', this.onMouseMove)
    },
    onMouseLeave () {
      this.$el.removeEventListener('mousemove', this.onMouseMove)

      this.isInitied = false
      this.stopParallax()
      this.$el.classList.remove('is-over')
    }
  },
  mounted () {
    this.startParallax()
  },
  beforeDestroy () {
    this.destroyParallax()
    this.$el.removeEventListener('mousemove', this.onMouseMove)
    this.$el.removeEventListener('mouseenter', this.onMouseEnter)
    this.$el.removeEventListener('mouseleave', this.onMouseLeave)
  }
}
